import useAppStateStore from "../../../shared/store/AppStateStore";
import { updateQuoteFields } from "../../../shared/utils/storeUtils";

const NewQuoteMapper = {
  set(data) {
    const STATE = useAppStateStore.getState();
    const setLookupAddress = STATE.setLookupAddress;

    // Occupation & Driver fields
    updateQuoteFields({
      "risk.drivers.0.occupations.0.occupationId": "D34",
      "risk.drivers.0.occupations.0.employmentStatusId": "S",
      "risk.drivers.0.occupations.0.employersBusinessId": "703",
      "risk.drivers.0.occupations.0.partTime": false,
      "risk.drivers.0.datePassedTest": data.risk.drivers[0].datePassedTest,
      "risk.drivers.0.uberDriverId": data.risk.drivers[0].uberDriverId,
      "risk.drivers.0.titleId": data.risk.drivers[0].titleId,
      "risk.drivers.0.forename": data.risk.drivers[0].forename,
      "risk.drivers.0.surname": data.risk.drivers[0].surname,
      "risk.drivers.0.emailAddress": data.risk.drivers[0].emailAddress,
      "risk.drivers.0.licenceNumber": data.risk.drivers[0].licenceNumber,
      "risk.drivers.0.telephone": data.risk.drivers[0].telephone,
      "risk.drivers.0.uberDriverRatingId":
        data.risk.drivers[0].uberDriverRatingId,
      "risk.drivers.0.dateOfBirth": data.risk.drivers[0].dateOfBirth,
      "risk.drivers.0.maritalStatusId": null,
      "risk.drivers.0.insuranceCancelled": null,
      "risk.vehicles.0.purchaseDate": null,
      "risk.vehicles.0.interiorCamera": null,
      "risk.vehicles.0.ncdDetails.years": null,
      "risk.vehicles.0.havePreviousRegistration": false,
      "risk.riskObjectId": data.risk.riskObjectId,
    });

    if (data.risk.sourceOfBusinessId && data.risk.sourceOfBusinessId !== "") {
      updateQuoteFields({
        "risk.sourceOfBusinessId": data.risk.sourceOfBusinessId,
      });
    }

    if (data.risk.campaignId && data.risk.campaignId !== "") {
      updateQuoteFields({
        "risk.campaignId": data.risk.campaignId,
      });
    }

    if (data.risk.activityId && data.risk.activityId !== "") {
      updateQuoteFields({
        "risk.activityId": data.risk.activityId,
      });
    }


    // Vehicle fields
    if (data.risk.vehicles && data.risk.vehicles.length > 0) {
      const vehicle = data.risk.vehicles[0];
      const vehicleFieldMap = Object.fromEntries(
        Object.entries(vehicle)
          .filter(
            ([key]) =>
              key !== "interiorCamera" &&
              key !== "purchaseDate" &&
              key !== "securityDevices" &&
              key !== "coverTypeId",
          )
          .map(([key, value]) => [`risk.vehicles.0.${key}`, value]),
      );
      updateQuoteFields(vehicleFieldMap);
    }
    if (data.isValidVehicleOnNewQuote === true) {
      STATE.setVehicleConfirmation(true);
    } else if (
      data.isValidVehicleOnNewQuote === false &&
      data.risk.vehicles &&
      data.risk.vehicles.length > 0
    ) {
      STATE.setIsManualVehicleEntry(true);
    } else {
      updateQuoteFields({
        "risk.vehicles.0.licensingPlateNumber": null,
      });
    }

    if (data.risk.uberMetrics) {
      updateQuoteFields({
        "risk.uberMetrics.lifetime_completed_trips":
          data.risk.uberMetrics.lifetime_completed_trips,
        "risk.uberMetrics.driver_rating": data.risk.uberMetrics.driver_rating,
        "risk.uberMetrics.uber_pro_tier": data.risk.uberMetrics.uber_pro_tier,
      });
    }

    // Address fields
    if (data.isValidAddressOnNewQuote) {
      updateQuoteFields({
        "risk.drivers.0.address": data.risk.drivers[0].address,
        "risk.drivers.0.address.postcode":
          data.risk.drivers[0].address.postcode,
        "risk.drivers.0.address.houseNo": data.risk.drivers[0].address.houseNo,
      });
      setLookupAddress(data.risk.drivers[0].address);
    }

    // State flags
    STATE.setIsValidVehicleOnNewQuote(data.isValidVehicleOnNewQuote);
    STATE.setIsValidAddressOnNewQuote(data.isValidAddressOnNewQuote);
  },
};

export default NewQuoteMapper;
